import React, { useState } from 'react';
import { useApp } from '../context/AppContext';

function Projects() {
  const { t } = useApp();
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      title: t('projects.cards.1.title'),
      description: t('projects.cards.1.description'),
      technologies: t('projects.cards.1.technologies'),
      image: "https://via.placeholder.com/300x200",
      github: "https://github.com/devthz/public-stocks-portfolio",
      demo: "https://public-stocks-portfolio.streamlit.app/?embed=true"
    }
  ];

  const handleDemoClick = (project) => {
    if (project.demo === "#") return;
    setSelectedProject(project);
  };

  return (
    <div className="min-h-screen pt-24 px-4">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold title-gradient mb-8">
          {t('projects.title')}
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <div key={index} className="glass-effect rounded-lg overflow-hidden hover-effect">
              <div className="p-6">
                <h2 className="text-xl font-semibold text-text-light dark:text-text-dark mb-2">
                  {project.title}
                </h2>
                <p className="card-text mb-4">
                  {project.description}
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.technologies.map((tech, techIndex) => (
                    <span
                      key={techIndex}
                      className="bg-background-light/50 dark:bg-background-dark/50 
                               text-text-light dark:text-text-dark px-2 py-1 rounded text-sm"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                <div className="flex space-x-4">
                  <a
                    href={project.github}
                    className="text-primary-light dark:text-primary-dark hover:opacity-80 transition-opacity"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    GitHub
                  </a>
                  {project.demo !== "#" && (
                    <button
                      onClick={() => handleDemoClick(project)}
                      className="text-primary-light dark:text-primary-dark hover:opacity-80 transition-opacity"
                    >
                      Demo
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal para o Demo */}
        {selectedProject && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                setSelectedProject(null);
              }
            }}
          >
            <div className="bg-background-light dark:bg-background-dark rounded-lg w-full max-w-7xl mx-auto">
              <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
                <h3 className="text-xl font-semibold text-text-light dark:text-text-dark">
                  {selectedProject.title}
                </h3>
                <button
                  onClick={() => setSelectedProject(null)}
                  className="text-text-light dark:text-text-dark hover:opacity-80"
                >
                  {t('common.close')}
                </button>
              </div>
              <div className="relative w-full bg-white" style={{ height: "80vh" }}>
                <iframe
                  src={selectedProject.demo}
                  className="w-full h-full"
                  title={`Demo ${selectedProject.title}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    margin: 0,
                    padding: 0,
                    display: 'block',
                    backgroundColor: 'white'
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Projects; 
